import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dms_token');
    const storedUser = localStorage.getItem('dms_user');
    const storedTenant = localStorage.getItem('dms_tenant');
    if (token && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        if (userData.type === 'super_admin') setIsSuperAdmin(true);
        if (storedTenant) setTenant(JSON.parse(storedTenant));
      } catch (e) {}
    }
    setLoading(false);
  }, []);

  const loginSuperAdmin = async (email, password) => {
    const res = await api.post('/super-admin/login', { email, password });
    const { token, user: userData } = res.data;
    localStorage.setItem('dms_token', token);
    localStorage.setItem('dms_user', JSON.stringify(userData));
    setUser(userData);
    setIsSuperAdmin(true);
    return res.data;
  };

  const loginTenant = async (email, password, tenantSlug) => {
    const res = await api.post('/auth/login', { email, password, tenantSlug });
    const { token, user: userData, tenant: tenantData } = res.data;
    localStorage.setItem('dms_token', token);
    localStorage.setItem('dms_user', JSON.stringify(userData));
    localStorage.setItem('dms_tenant', JSON.stringify(tenantData));
    setUser(userData);
    setTenant(tenantData);
    setIsSuperAdmin(false);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('dms_token');
    localStorage.removeItem('dms_user');
    localStorage.removeItem('dms_tenant');
    setUser(null);
    setTenant(null);
    setIsSuperAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, isSuperAdmin, loading, loginSuperAdmin, loginTenant, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
